module.exports = __webpack_public_path__ + "img/bg-icon.63cb0d87.svg";